import SEO from './seo';

export { SEO };
